var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip:left",value:(_vm.fullPostback),expression:"fullPostback",arg:"left"}],staticClass:"btn btn-primary fullPostbackTooltip"},[_vm._v("\n    Link\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }